import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';
const GoogleTagManager = ({ gtmId }: { gtmId: string }) => {
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // 개발 환경 체크
    const env = process.env.REACT_APP_JEBS_APP_URL || '';
    const isDev = env.includes('dev');

    if (isDev) {
      console.log('[GTM] 개발 환경 - GTM 비활성화됨');
      return;
    }

    if (!gtmId) {
      console.warn('[GTM] GTM ID가 없습니다');
      return;
    }

    TagManager.initialize({ gtmId });
    setIsInitialized(true);
    console.log('[GTM] 운영 환경 - GTM 활성화됨');
  }, [gtmId]);

  useEffect(() => {
    // 개발 환경이거나 초기화되지 않은 경우 pageview 이벤트 전송 안함
    if (!isInitialized) return;

    const pagePath = location.pathname + location.search;
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: pagePath,
      },
    });
  }, [location, isInitialized]);

  return <></>; // Empty fragment since this component doesn't render anything
};
export default GoogleTagManager;
